module.exports = __webpack_public_path__ + "files/bf5118257d90451065e94b70a485c07b.png";